import * as React from 'react';

const Tablet = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="27" height="21" viewBox="0 0 27 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.36466 18.7687L0.776465 9.10941C0.34764 7.50901 1.29739 5.864 2.89779 5.43517L20.2845 0.77643C21.8848 0.347604 23.5299 1.29735 23.9587 2.89775L26.5469 12.557C26.9757 14.1574 26.026 15.8024 24.4256 16.2312L7.03889 20.89C5.43849 21.3188 3.79348 20.3691 3.36466 18.7687ZM7.00466 18.8287L21.9765 14.817C22.2432 14.7455 22.4015 14.4714 22.3301 14.2046L19.4831 3.57946C19.4116 3.31273 19.1374 3.15444 18.8707 3.22591L3.89883 7.2376C3.63209 7.30907 3.4738 7.58324 3.54527 7.84997L6.39228 18.4752C6.46376 18.7419 6.73792 18.9002 7.00466 18.8287Z"
      fill="black"
    />
  </svg>
);

export default Tablet;
